import { Button, Center, Stack, Text, Title } from "@mantine/core";

import { signIn } from "@/auth/provider";
import { t } from "@/i18n";

/**
 * Where the browser lands after sign out (docs#15 note 16577). It does not redirect to
 * IAM on its own: on a shared lab computer the next person decides to sign in, with
 * their own account.
 */
export function SignedOutPage(): JSX.Element {
  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Title order={2}>{t("signed_out.title")}</Title>
        <Text c="dimmed">{t("signed_out.body")}</Text>
        <Button onClick={() => void signIn("/")}>{t("signed_out.sign_in")}</Button>
      </Stack>
    </Center>
  );
}
